<template>
  <b-col md="12">
    <section class="accommodations">
      <div class="accommodations__header">
        <p class="mb-0">
          <strong class="semibold text--lg text-primary">Sistemazione degli ospiti per camera</strong><br />
          <span>Verifica che ogni camera sia adatta al numero e alla tipologia di viaggiatori altrimenti seleziona una camera diversa.</span>
        </p>
        <vb-button
          v-b-modal="'accommodations_modal'"
          :vb_options="{
            size: 'sm',
            variant: 'white'
          }"
        >
          <span>Cambia camera</span>
        </vb-button>
      </div>
      <accommodations-recap :solution="solution" />
      <div
        v-if="has_occupancy_mismatch"
        class="accommodations__alert"
      >
        <p class="accommodations__alert-title">
          <vb-icon class="mr-1" :name="'exclamation'" :color="sass('danger')" :size="16" />
          <span>Una o più camere non hanno spazio per tutti gli ospiti.</span>
        </p>
        <p class="accommodations__alert-desc">
          <span>Modifica la selezione delle camere per accogliere tutti gli ospiti.</span>
          <br />
          <span v-b-modal="'accommodations_modal'">Puoi scegliere nuovamente le camere.</span>
        </p>
      </div>
      <vb-modal
        :vb_options="{
          id: 'accommodations_modal',
          body_class: 'accommodations__modal',
          title: 'Modifica la tua scelta',
          size: 'md',
          button_size: 'sm',
          ok_title: 'Procedi',
          ok_only: true,
          centered: true,
        }"
        @ok="$router.push('/detail')"
      >
        <p>Se clicchi su Procedi, la precedente scelta delle camere verrà annullata e potrai farla di nuovo.</p>
      </vb-modal>
    </section>
  </b-col>
</template>

<script>
import AccommodationsRecap from "@bookingv3/components/blocks/checkout/accommodations-recap.vue"

export default {
  name: 'accommodations',
  
  components: {
    'accommodations-recap': AccommodationsRecap,
  },

  inheritAttrs: false,

  props: {
    solution: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
    }
  },

  computed: {
    // true se almeno una camera ha un occupancy_mismatch dalla preview
    has_occupancy_mismatch() {
      const { accommodation } = this.solution
      const products = (accommodation && accommodation.products) || []

      return products.some(product => product.occupancy_mismatch)
    },
  },
}
</script>

<style lang="scss" scoped>

  .accommodations {
    margin-top: $grid-gutter-width*2;

    &__header {
      margin-bottom: 20px;

      @include media-breakpoint-up(md) {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
      }

      .btn {
        margin-top: 20px;

        @include media-breakpoint-up(md) {
          margin-top: 0;
        }

        &-white {
          background-color: $white;
        }
      }
    }

    &__alert {
      color: $danger;
      margin-top: 2/3*$grid-gutter-width;

      &-title {
        display: flex;
        align-items: center;
        font-weight: $vb-font-weight-semibold;
        margin-bottom: $grid-gutter-width/3;
      }

      &-desc {
        margin-bottom: 0;
        color: $vb-body-color;

        span:last-child, a {
          color: $info;
          text-decoration: underline;
        }
      }
    }

  }

</style>